import _styled from '@emotion/styled/base';
import { keyframes, useTheme, jsx, css } from '@emotion/react';
import PropTypes from 'prop-types';
import 'react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const VIEWBOX_WIDTH = 100;
const VIEWBOX_HEIGHT = 100;
const HALF_VIEWBOX_WIDTH = VIEWBOX_WIDTH / 2;
const HALF_VIEWBOX_HEIGHT = VIEWBOX_HEIGHT / 2;
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Text = /*#__PURE__*/ /*#__PURE__*/_styled('text', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => !['color'].includes(prop.toString()),
  target: "e1cu28gc0"
} : {
  shouldForwardProp: prop => !['color'].includes(prop.toString()),
  target: "e1cu28gc0",
  label: "Text"
})("fill:", _ref2 => {
  var _theme$colors;

  let {
    theme,
    color
  } = _ref2;
  return ((_theme$colors = theme.colors[color]) == null ? void 0 : _theme$colors.backgroundStrong) || color;
}, ";font-size:26px;dominant-baseline:middle;text-anchor:middle;");

var _ref = process.env.NODE_ENV === "production" ? {
  name: "si0mpz",
  styles: "transition:stroke-dashoffset 0.5s ease 0s"
} : {
  name: "11f05l0-Loader",
  styles: "transition:stroke-dashoffset 0.5s ease 0s;label:Loader;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Loader = _ref3 => {
  var _theme$colors2, _theme$colors3;

  let {
    percentage = 20,
    text,
    size = 40,
    strokeWidth = 16,
    color = 'primary',
    trailColor = 'neutral',
    active = false,
    label = 'Loading'
  } = _ref3;
  const theme = useTheme();
  const circleRadius = HALF_VIEWBOX_HEIGHT - strokeWidth / 2;
  const boundedPercentage = Math.min(Math.max(percentage, 0), 100) / 100;
  const circleDiameter = Math.PI * 2 * circleRadius;
  return jsx("svg", {
    role: "progressbar",
    "aria-label": label,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": percentage,
    "aria-valuetext": `${percentage}%`,
    css: active && /*#__PURE__*/css("animation:", spin, " 0.75s linear infinite;" + (process.env.NODE_ENV === "production" ? "" : ";label:Loader;")),
    viewBox: `0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`,
    style: {
      height: typeof size === 'string' ? size : `${size}px`,
      width: typeof size === 'string' ? size : `${size}px`
    }
  }, jsx("circle", {
    cx: HALF_VIEWBOX_WIDTH,
    cy: HALF_VIEWBOX_HEIGHT,
    r: circleRadius,
    fill: "none",
    strokeWidth: strokeWidth,
    stroke: ((_theme$colors2 = theme.colors[trailColor]) == null ? void 0 : _theme$colors2.borderWeak) || trailColor
  }), jsx("circle", {
    css: _ref,
    cx: HALF_VIEWBOX_WIDTH,
    cy: HALF_VIEWBOX_HEIGHT,
    r: circleRadius,
    fill: "none",
    strokeWidth: strokeWidth,
    strokeDasharray: circleDiameter,
    strokeDashoffset: (1 - boundedPercentage) * circleDiameter,
    stroke: ((_theme$colors3 = theme.colors[color]) == null ? void 0 : _theme$colors3.backgroundStrong) || color,
    strokeLinecap: "round"
  }), text ? jsx(Text, {
    color: color,
    x: HALF_VIEWBOX_WIDTH,
    y: HALF_VIEWBOX_HEIGHT
  }, text) : null);
};

Loader.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,

  /**
   * Label should be defined for accessibility, to indicate what is loading
   */
  label: PropTypes.string,
  percentage: PropTypes.number,
  size: /*#__PURE__*/PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeWidth: PropTypes.number,

  /**
   * Text is placed in center of ProgressCircle.
   */
  text: PropTypes.string,
  trailColor: PropTypes.string
};
var Loader$1 = Loader;

export { Loader$1 as default };
